import { TeilnehmerVO } from "@core/api/v1";
import GutachterTaetigkeitenEnum = TeilnehmerVO.GutachterTaetigkeitenEnum;

export const gutachterTaetigkeitOptionen: { label: string, value: GutachterTaetigkeitenEnum }[] = [
    {label: 'kein Gutachtertätigk.', value: GutachterTaetigkeitenEnum.KEINE },
    {label: 'AUVA', value: GutachterTaetigkeitenEnum.AUVA },
    {label: 'BVAEB', value: GutachterTaetigkeitenEnum.BVAEB },
    {label: 'PVA', value: GutachterTaetigkeitenEnum.PVA },
    {label: 'SVS', value: GutachterTaetigkeitenEnum.SVS }
];
